import React from "react";

const FeaturedSection = () => {
  return (
    <section id="featured" className="featured">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="icon-box">
              <i className="bi bi-card-checklist"></i>
              <h3>
                <a href="">Преводи от и на 20+ езика</a>
              </h3>
              <p>
                Ние осигуряваме професионални преводи от и на повече от 20
                езика, гарантирайки ви ефективна комуникация в глобален мащаб.
              </p>
            </div>
          </div>
          <div className="col-lg-4 mt-4 mt-lg-0">
            <div className="icon-box">
              <i className="bi bi-bar-chart"></i>
              <h3>
                <a href="">Редакция на текст</a>
              </h3>
              <p>
                Внимателно и професионално преглеждане на текстовете, за да
                гарантираме тяхната ясност, граматична точност и стилова
                перфекция.
              </p>
            </div>
          </div>
          <div className="col-lg-4 mt-4 mt-lg-0">
            <div className="icon-box">
              <i className="bi bi-binoculars"></i>
              <h3>
                <a href="">Гарантирано качество</a>
              </h3>
              <p>
                Нашите услуги се отличават с гарантирано качество, което ви
                осигурява надеждност и увереност в резултатите.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
